import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { usePromisedRequest as promiseRequest } from "../Common/request";
import { Bundle } from "../Common/consts";

export type EventOrganizer = {
    id: number;
    name: string;
    email: string;
    role: string;
    bundles: Bundle[];
};

export default {
    getListing(eventId: number): Promise<EventOrganizer[]> {
        return promiseRequest<EventOrganizer[]>({
            url: `/api/admin/events/${eventId}/organizers`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    removeOrganizer(eventId: number, eventUserId: number): Promise<void> {
        return promiseRequest<void>({
            url: `/api/admin/events/${eventId}/organizers/${eventUserId}`,
            method: "delete",
            json: true,
        }).then(resolveNoContent());
    },
    addOrganizer(eventId: number, email: string, role: string, bundles: Bundle[]): Promise<void> {
        return promiseRequest<void>({
            url: `/api/admin/events/${eventId}/organizers`,
            method: "post",
            json: {
                eventId,
                email,
                role,
                bundles,
            },
        }).then(resolveNoContent());
    },
    updateOrganizer(eventId: number, eventUserId: number, role: string, bundles: Bundle[]): Promise<void> {
        return promiseRequest<void>({
            url: `/api/admin/events/${eventId}/organizers/${eventUserId}`,
            method: "put",
            json: {
                eventId,
                eventUserId,
                role,
                bundles,
            },
        }).then(resolveNoContent());
    },
};
